export const RESET_APP_ERRORS = 'RESET_APP_ERRORS';



// WEBPACK FOOTER //
// ./src/models/application/constants.js